
import React, { Fragment, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";

import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";

import reducer from "./reducer";
import saga from "./saga";
import {
  makeSelectDivisionsAvailable,
  makeSelectDivisionsData,
  makeSelectIsErrorStatus,
  makeSelectIsLoading,
  makeSelectIsLoadingSubDivision,
  makeSelectIsLoadingTab,
  makeSelectIsMeasureProcess,
  makeSelectMeasureColorRange,
  makeSelectMeasureGeneral,
  makeSelectMeasureInfo,
  makeSelectMeasureTotal,
  makeSelectTypeMeasurement,
  makeSelectUserType,
} from "./selectors";
import {
  getMeasureColorRangeWatcher,
  getMeasureInfoWatcher,
  getMeasureTotalSubDivisionWatcher,
  getMeasureTotalWatcher,
  getStatusWatcher,
} from "./actions";
import "./index.less";

import { get } from "lodash";
import { Button, Popover, Spin, Tabs } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";

import {
  isAmbassadorOrLeaderActive,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../utils/storage";
import { MEASURE_STATUS, TYPE_SURVEY } from "../../../utils/constants";
import { uuid, validate } from "../../../utils/functions";
import SelectHR from "../../../components/Select";
import ClimateMeasurement from "../../components/ClimateMeasurement";
import EngagementMeasurement from "../../components/EngagementMeasurement";
import LeadershipMeasurement from "../../components/LeadershipMeasurement";
import EmptyStateAnonymity from "../../../components/EmptyStateAnonymity";
import EmptyStateAmbassador from "./components/EmptyStateAmbassador";
import { getMeditionsAvailableActionsWatcher } from "../ReportHeaderV2/actions";
import { loadTexts } from "../../../utils/i18n";

const { TabPane } = Tabs;

export function ReportAmbassador(props) {
  const intl = loadTexts("reports_general_view");
  const [idDivisionSelected, setDivisionSelected] = useState(props.divisionID);
  const [idDivisionParent, setDivisionParent] = useState(props.parentDivisionID);
  const [deleteSelection, setDeleteSelection] = useState(false);
  const [idSegmentSelected, setIdSegmentSelected] = useState(undefined);

  const fetchedSubDivisionRef = useRef(false);
  const fetchedParentRef = useRef(false);

  useEffect(() => {
    if (!validate.exist(props.divisionID)) {
      setDivisionSelected(null);
    }
    setIdSegmentSelected(undefined);
    initGetData(null);
    props.getMeasureColorRange({ measure: props.idMeasure });
  }, [props.idMeasure]);

  useEffect(() => {
    fetchedSubDivisionRef.current = false;
    fetchedParentRef.current = false;
  }, [props.idMeasure]);

  useEffect(() => {
    if (
      validate.exist(idDivisionSelected) &&
      idDivisionSelected !== props.divisionID &&
      !deleteSelection &&
      props.isLoadingSubDivision === false &&
      !fetchedSubDivisionRef.current
    ) {
      fetchedSubDivisionRef.current = true;
      getMeasureTotalChangeSubDivision();
    } else if (deleteSelection && !fetchedParentRef.current) {
      fetchedParentRef.current = true;
      getMeasureTotalChangeParent();
    }
  }, [idDivisionSelected, deleteSelection, props.isLoadingSubDivision]);

  useEffect(() => {
    if (props.measureGeneral?.id_measure) {
      props.onMeasureGeneralSelected?.(props.measureGeneral);
    }
  }, [props.measureGeneral]);

  useEffect(() => {
    const { idMeasure, history } = props;
    let paramsSegment = "";
    let paramsDivision = "";
    let paramsDivisionParent = "";

    if (validate.exist(idDivisionSelected)) {
      paramsDivision = validate.empty(idDivisionSelected) ? "" : `&id_division=${idDivisionSelected}`;
    } else {
      paramsDivisionParent = validate.empty(idDivisionParent) ? "" : `&id_divisionParent=${idDivisionParent}`;
    }

    if (!validate.empty(idSegmentSelected)) {
      props.getMeasureInfo({
        idMeasure,
        id_segment: idSegmentSelected,
        params: { idMeasure, id_segment: idSegmentSelected },
      });
      paramsSegment = `&id_segment=${idSegmentSelected}`;
      history.push({
        pathname: history.location.pathname,
        search: `?f${paramsDivision}${paramsDivisionParent}${paramsSegment}`,
      });
    } else {
      history.push({
        pathname: history.location.pathname,
        search: `?f${paramsDivision}${paramsDivisionParent}`,
      });
    }
  }, [idSegmentSelected]);

  useEffect(() => {
    if (
      validate.exist(idDivisionParent) &&
      idDivisionParent !== props.parentDivisionID &&
      props.isLoadingTab === false
    ) {
      getMeasureTotalChangeParent();
    }
  }, [idDivisionParent]);

  useEffect(() => {
    if (
      validate.exist(props.userType) &&
      validate.exist(props.userType.select_division) &&
      !validate.exist(idDivisionParent) &&
      get(props.measureGeneral, "id_measure") === props.idMeasure
    ) {
      setDivisionParent(props.userType.select_division);
    }
  }, [props.userType]);

  const initGetData = (segmentOverride) => {
    const { idMeasure, history, getStatus } = props;
    const addParamsSegment = paramsSegment(segmentOverride);
    if (validate.exist(idDivisionSelected)) {
      history.push(`${history.location.pathname}?id_division=${idDivisionSelected}&id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    } else if (validate.exist(idDivisionParent)) {
      history.push(`${history.location.pathname}?id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    }
    getStatus({
      isHome: true,
      id_measure: idMeasure,
      history,
      isExclude: LOCAL_CHECKBOX_EXCLUDE() === "true" && LOCAL_ISOLATED_METRICS() === "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_divisionParent: idDivisionParent,
      },
    });

    props.getAvailableActions({
      measure_id: idMeasure,
      id_division: validate.exist(idDivisionSelected) ? idDivisionSelected : idDivisionParent,
    });
  };

  const paramsSegment = (segmentOverride) => {
    const segment = segmentOverride !== undefined ? segmentOverride : idSegmentSelected;
    return validate.empty(segment) ? "" : `&id_segment=${segment}`;
  };

  const setIdSegment = (segment) => {
    const idSegment = segment.split("-");
    let response = !validate.empty(idSegment[1]) ? idSegment[1] : undefined;
    setIdSegmentSelected(response);
  };

  const getMeasureTotalChangeSubDivision = () => {
    const { idMeasure, history, getMeasureTotalSubDivision } = props;
    const addParamsSegment = paramsSegment();
    if (validate.exist(idDivisionSelected)) {
      history.push(`${history.location.pathname}?id_division=${idDivisionSelected}&id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    } else if (validate.exist(idDivisionParent)) {
      history.push(`${history.location.pathname}?id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    }
    setDeleteSelection(false);
    getMeasureTotalSubDivision({
      isHome: true,
      id_measure: idMeasure,
      history,
      isExclude: LOCAL_CHECKBOX_EXCLUDE() === "true" && LOCAL_ISOLATED_METRICS() === "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_divisionParent: idDivisionParent,
      },
    });

    props.getAvailableActions({
      measure_id: idMeasure,
      id_division: validate.exist(idDivisionSelected) ? idDivisionSelected : idDivisionParent,
    });
  };

  const getMeasureTotalChangeParent = () => {
    const { idMeasure, history, getMeasureTotalParent } = props;
    const addParamsSegment = paramsSegment();
    if (validate.exist(idDivisionSelected)) {
      history.push(`${history.location.pathname}?id_division=${idDivisionSelected}&id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    } else if (validate.exist(idDivisionParent)) {
      history.push(`${history.location.pathname}?id_divisionParent=${idDivisionParent}${addParamsSegment}`);
    }
    setDeleteSelection(false);
    getMeasureTotalParent({
      isHome: true,
      id_measure: idMeasure,
      history,
      isExclude: LOCAL_CHECKBOX_EXCLUDE() === "true" && LOCAL_ISOLATED_METRICS() === "true",
      params: { id_measure: idMeasure, id_division: idDivisionParent },
    });

    props.getAvailableActions({
      measure_id: idMeasure,
      id_division: validate.exist(idDivisionSelected) ? idDivisionSelected : idDivisionParent,
    });
  };


  const renderContent = (id_division, idSegment, nameDivision, segmentName) => {
    console.log('llamando renderContent', id_division, idSegment, nameDivision, segmentName)
    const {
      idMeasure,
      measureGeneral,
      measureTotal,
      history,
      typeMeasurement,
      isLoadingTab,
      isLoadingSubDivision,
      measureInfo,
    } = props
    /* if (isLoadingTab || isLoadingSubDivision || changeDivision) {
      return (
        <div className="loadingSpin">
          <Spin />
        </div>
      )
    } */
    if (id_division !== idDivisionParent) {
      return null
    }

    /* if (validationEmptyState()) {
      return renderEmpty()
    } */

    let measureInfoTotal = { ...measureTotal }
    if (validate.exist(measureInfo) && !validate.empty(measureInfo)) {
      measureInfoTotal = { ...measureTotal, ...props.measureInfo }
    }

    switch (typeMeasurement) {
      case TYPE_SURVEY.climate.slugSurveyType:
        return (
          <Fragment key={uuid()}>
            {renderNameMeasure(nameDivision, idSegment, segmentName)}
            {renderSelectDivision()}
            <ClimateMeasurement
              typeMeasurement={typeMeasurement}
              idMeasure={idMeasure}
              measureTotal={measureInfoTotal}
              measureGeneral={measureGeneral}
              idDivisionSelected={idDivisionSelected}
              idDivisionParent={idDivisionParent}
              isLoading={isLoadingSubDivision}
              selectedSegment={idSegment}
              divisionsData={props.divisionsData}
            />
          </Fragment>
        )
      case TYPE_SURVEY.engagement.slugSurveyType:
        return (
          <Fragment key={uuid()}>
            {renderNameMeasure(nameDivision, idSegment, segmentName)}
            {renderSelectDivision()}
            <EngagementMeasurement
              typeMeasurement={typeMeasurement}
              idMeasure={idMeasure}
              history={history}
              measureGeneral={measureGeneral}
              measureTotal={measureInfoTotal}
              idDivisionSelected={idDivisionSelected}
              idDivisionParent={idDivisionParent}
              isLoadingFilter={isLoadingSubDivision}
              selectedSegment={idSegment}
            />
          </Fragment>
        )
      case TYPE_SURVEY.leadership.slugSurveyType:
        return (
          <Fragment key={uuid()}>
            {renderNameMeasure(nameDivision, idSegment, segmentName)}
            {renderSelectDivision()}
            <LeadershipMeasurement
              typeMeasurement={typeMeasurement}
              idMeasure={idMeasure}
              measureTotal={measureInfoTotal}
              measureGeneral={measureGeneral}
              isLoading={isLoadingSubDivision}
              selectedSegment={idSegment}
            />
          </Fragment>
        )
    }
    return <div>render data</div>
  }

  const handleDivisionChange = (idDivision) => {
    if (!validate.exist(idDivision)) {
      setDeleteSelection(true)
    }
    setDivisionSelected(
      validate.exist(idDivision) ? parseInt(idDivision) : null
    )
  }

  const renderSelectDivision = () => {
    const { divisionsAvailable } = props
    return (
      <div style={{ display: "flex", alignItems: "baseline", gap: "0.5rem" }}>
        <div className="reportAmbassador__legend-division">
          {intl.reportAmbassador.selectDivision.label}
        </div>
        <div>
          <SelectHR
            allowClear
            value={idDivisionSelected}
            options={divisionsAvailable}
            placeholder={intl.reportAmbassador.selectDivision.placeholder}
            style={{ width: 200 }}
            label="name"
            labelKey="id_division"
            onChange={(selectedDivision) =>
              handleDivisionChange(
                selectedDivision ? selectedDivision.id_division : null
              )
            }
          />
        </div>
      </div>
    )
  }

  const renderNameMeasure = (nameDivision, idSegment, segmentName) => {
    const { measureGeneral } = props
    const { name } = measureGeneral

    const nameConcat = validate.empty(idSegment) ? nameDivision : segmentName

    return (
      <div className="name-measure-with-division">
        <b>{`${name} -`}</b> {`${nameConcat}`}
      </div>
    )
  }

  const renderLegendColor = (item) => {
    return (
      <Fragment key={uuid()}>
        <div className="reportAmbassador__legend-content">
          <div
            className="reportAmbassador__legend-color"
            style={{
              background: `rgb(${item.rgb.r},${item.rgb.g},${item.rgb.b})`,
            }}
          />
          <div className="reportAmbassador__legend-label-value">{`${item.start} ${intl.reportAmbassador.legendTo} ${item.finish}`}</div>
        </div>
        {Number(item.finish) !== 100 && (
          <hr className="reportAmbassador__legend-divider" />
        )}
      </Fragment>
    )
  }

  const legendColor = () => {
    const { measureColorRange } = props
    let data = measureColorRange.filter((row) => row.disabled !== true)
    if (!validate.exist(data) || data.length === 0) {
      return null
    }
    const content = <div>{data.map((item) => renderLegendColor(item))}</div>
    return (
      <Popover
        content={content}
        title={intl.reportAmbassador.tooltipLegend}
        placement="bottom">
        <Button className="reportAmbassador__legend" type="link">
          <span>{intl.reportAmbassador.legend}</span> <QuestionCircleFilled />
        </Button>
      </Popover>
    )
  }

  const handleTabsChange = (activeKey) => {
    setDivisionSelected(null)
    setDivisionParent(parseInt(activeKey))
  }

  const renderEmpty = () => {
    const { userType, measureGeneral, measureTotal } = props
    return (
      <EmptyStateAmbassador
        userType={userType}
        measureGeneral={measureGeneral}
        measureTotal={measureTotal}
        measureEngagement={measureTotal}
      />
    )
  }

  const validationEmptyState = () => {
    const {
      userType,
      measureGeneral,
      measureTotal,
      isMeasureProcess,
      isLoadingTab,
    } = props

    return (
      !validate.exist(measureGeneral) ||
      (isLoadingTab && !validate.exist(measureTotal)) ||
      !isMeasureProcess ||
      get(userType, "is_empty", true) ||
      !get(userType, "anonymity_check", true) ||
      [
        MEASURE_STATUS.in_progress.id_measure_status,
        MEASURE_STATUS.finished.id_measure_status,
      ].includes(get(measureGeneral, "id_measure_status", 0))
    )
  }

  const renderHeaderReport = () => {
    const { userType, measureGeneral } = props
    const { divisions: listDivisions } = userType

    const anonymityCount = isAmbassadorOrLeaderActive()
      ? LOCAL_ANONYMITY()
      : LOCAL_ANONYMITY_LEADERS()
    const divisionSelectedInfo = [...listDivisions].find(
      (d) => d.id_division === idDivisionParent
    )
    const anonymityValidate =
      divisionSelectedInfo &&
      divisionSelectedInfo.employees < parseInt(anonymityCount)

    if (anonymityValidate) {
      return (
        <div className="reportAmbassador__Header">
          <Tabs
            defaultActiveKey={`${idDivisionParent}`}
            className="reportAmbassador__Header-tab"
            animated={false}>
            <TabPane
              tab={get(divisionSelectedInfo, "name", "")}
              key={idDivisionParent}
              className="reportAmbassador__Header-tab-container">
              <div style={{ minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <EmptyStateAnonymity
                  count={get(divisionSelectedInfo, "employees", 0)}
                />
              </div>
            </TabPane>
          </Tabs>
        </div>
      )
    }

    if (!get(userType, "anonymity_check.valid", true)) {
      const divisionName = divisionSelectedInfo
        ? get(divisionSelectedInfo, "name", "")
        : get(listDivisions, "[0].name", "")
      return (
        <div className="reportAmbassador__Header">
          <Tabs
            defaultActiveKey={`${idDivisionParent}`}
            className="reportAmbassador__Header-tab"
            animated={false}>
            <TabPane
              tab={divisionName}
              key={idDivisionParent}
              className="reportAmbassador__Header-tab-container">
              <div style={{ minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <EmptyStateAnonymity
                  count={get(userType, "anonymity_check.current_used", 0)}
                />
              </div>
            </TabPane>
          </Tabs>
        </div>
      )
    }

    if (validationEmptyState()) {
      return renderEmpty()
    }
    const tabs = []

    listDivisions.forEach((division) => {
      if (division.employees) {
        const { id_division, name } = division
        let selectedSegmentId = null
        let selectedSegmentName = ''

        if (measureGeneral.segments.length === 1) {
          selectedSegmentId = measureGeneral.segments[0].id_segment
          selectedSegmentName = measureGeneral.segments[0].name
        }

        tabs.push(
          <TabPane
            tab={name}
            key={id_division}
            forceRender={false}
            className="reportAmbassador__Header-tab-container">
            {renderContent(id_division, selectedSegmentId, name, selectedSegmentName)}
          </TabPane>
        )

        if (measureGeneral.segments.length > 1) {
          measureGeneral.segments.forEach((segment) => {
            tabs.push(
              <TabPane
                tab={`${name} - ${segment.name}`}
                key={`${id_division}-${segment.id_segment}`}
                forceRender={false}
                className="reportAmbassador__Header-tab-container">
                {renderContent(
                  id_division,
                  segment.id_segment,
                  name,
                  segment.name
                )}
              </TabPane>
            )
          })
        }
      }
    })

    return (
      <div className="reportAmbassador__Header">
        <Tabs
          tabBarExtraContent={legendColor()}
          // activeKey={`${idDivisionParent}`}
          defaultActiveKey={`${idDivisionParent}`}
          onChange={(activeKey) => handleTabsChange(activeKey)}
          onTabClick={(item) => setIdSegment(item)}
          className="reportAmbassador__Header-tab"
          animated={false}>
          {
            /* map(listDivisions, ({ name, id_division }) => {
            return (
              <TabPane
                tab={name}
                key={id_division}
                className="reportAmbassador__Header-tab-container">
                {renderContent(id_division)}
              </TabPane>
            )
          }) */ tabs
          }
        </Tabs>
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <div className="reportAmbassador">
        <div className="loadingSpin">
          <Spin />
        </div>
      </div>
    )
  }

  // Spinner cuando measureGeneral corresponde a otra medición (datos stale del Redux)
  if (
    validate.exist(props.measureGeneral) &&
    get(props.measureGeneral, "id_measure") &&
    get(props.measureGeneral, "id_measure") !== props.idMeasure
  ) {
    return (
      <div className="reportAmbassador">
        <div className="loadingSpin">
          <Spin />
        </div>
      </div>
    )
  }

  if (
    !validate.exist(props.measureGeneral) ||
    !validate.exist(props.userType)
  ) {
    return null
  }

  return <div className="reportAmbassador">{renderHeaderReport()}</div>
}

ReportAmbassador.propTypes = {
  parentDivisionID: PropTypes.number,
  divisionID: PropTypes.number,
  isLoading: PropTypes.bool,
  history: PropTypes.object,
  idMeasure: PropTypes.number,
  currentMeasure: PropTypes.object,
  isMeasureProcess: PropTypes.bool,
  divisionsAvailable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureGeneral: PropTypes.object,
  measureTotal: PropTypes.object,
  isErrorStatus: PropTypes.bool,
  measureColorRange: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getStatus: PropTypes.func,
  getMeasureColorRange: PropTypes.func,
  typeMeasurement: PropTypes.string,
  userType: PropTypes.object,
  isLoadingTab: PropTypes.bool,
  getMeasureTotalSubDivision: PropTypes.func,
  getMeasureTotalParent: PropTypes.func,
  getAvailableActions: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  isMeasureProcess: makeSelectIsMeasureProcess(),
  divisionsAvailable: makeSelectDivisionsAvailable(),
  divisionsData: makeSelectDivisionsData(),
  measureTotal: makeSelectMeasureTotal(),
  measureGeneral: makeSelectMeasureGeneral(),
  isErrorStatus: makeSelectIsErrorStatus(),
  measureColorRange: makeSelectMeasureColorRange(),
  typeMeasurement: makeSelectTypeMeasurement(),
  userType: makeSelectUserType(),
  isLoadingTab: makeSelectIsLoadingTab(),
  isLoadingSubDivision: makeSelectIsLoadingSubDivision(),
  measureInfo: makeSelectMeasureInfo(),
})

function mapDispatchToProps(dispatch) {
  return {
    getStatus: (params) => dispatch(getStatusWatcher(params)),
    getMeasureColorRange: (params) =>
      dispatch(getMeasureColorRangeWatcher(params)),
    getMeasureTotalSubDivision: (params) =>
      dispatch(getMeasureTotalSubDivisionWatcher(params)),
    getMeasureTotalParent: (params) => dispatch(getMeasureTotalWatcher(params)),
    getAvailableActions: (params) =>
      dispatch(getMeditionsAvailableActionsWatcher(params)),
    getMeasureInfo: (params) => dispatch(getMeasureInfoWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "reportAmbassador", reducer })
const withSaga = injectSaga({ key: "reportAmbassador", saga })

export default compose(withReducer, withSaga, withConnect)(ReportAmbassador)
